import React from 'react';
import { usePrefs } from 'ws-scripts/modules/common';
import { useSelector } from 'react-redux';
import Ratings from './Ratings';
import StarRating from './StarRating';

const IconAndRatings = () => {
	const kbbCustomerRatings = useSelector((state) => state.ratings);
	const prefs = usePrefs();

	const { ratings, ratingScale = 5 } = kbbCustomerRatings;
	const { KBBLogoColor, useHorizontalStyle, useInverseTextColor } = prefs;

	const textColor = useInverseTextColor === 'true' ? 'text-inverse' : '';

	if (useHorizontalStyle === 'true') {
		return (
			<div className="kbb-header d-flex align-items-center">
				<img
					alt="Kelley Blue Book Logo"
					src="/static/assets/images/logos/kbb/kbb.svg"
					width={32}
					height={32}
				/>
				{ratings && (
					<>
						<strong
							className={`ddc-font-size-xlarge d-block font-weight-bold mx-2 ${textColor}`}
						>
							{ratings[0]?.value}
						</strong>
						<span className={textColor}>
							out of {ratingScale} overall
						</span>
						<StarRating
							rating={+ratings[0]?.value}
							ratingScale={ratingScale}
						/>
					</>
				)}
			</div>
		);
	}

	return (
		<div className="kbb-header d-flex align-items-center">
			<div className="kbb-logo-container">
				<img
					src={`https://static.dealer.com/global/media/logos/kbb/horizontal/${KBBLogoColor}/180x102.png`}
					alt="Kelley Blue Book - KBB.com"
					width={180}
					height={102}
				/>
			</div>
			<Ratings
				ratings={ratings}
				ratingScale={ratingScale}
				prefs={prefs}
			/>
		</div>
	);
};

export default IconAndRatings;
